// https://digital.vfc.com/wiki/spaces/AN/pages/356786124/Country+and+Langugage+Selectors

const baseEvent = {
  event: 'loadEventData',
  eventAction: 'Popup',
  eventCategory: 'Language Selector',
  nonInteractive: 0,
  customMetrics: {},
  customVariables: {}
}

export default {
  onImpression: () => ({
    ...baseEvent,
    eventLabel: 'Impression',
  }),
  onClickLanguageSelector: (eventLabel: string) => ({
    ...baseEvent,
    eventLabel: `Switch to ${eventLabel}`
  })
}
